import { USER_MSG } from "../types/index";
const initialState = {
  name: "user",
  type: 1,
  permission: []
};

export default (state = initialState, action) => {
  switch (action.type) {
    case USER_MSG:
      return {
        ...state,
        name: action.usermsg.name,
        type: action.usermsg.type,
        permission: action.usermsg.permission
      };
    default:
      return state;
  }
};
